module.exports = __webpack_public_path__ + "static/media/color.55f8804a.png";